import React, { useState } from 'react'
import { bind } from '@src/utils'
import Main from '@src/components/main'
import { Container, DropdownButton, Dropdown } from 'react-bootstrap'
import * as ReactIcons from '@src/lib/react-icons'
import { DashboardViewModel, IDashboardViewModel } from './dashboard.view-model'
import './style.scss'
import { findIndex } from '@src/lib/lodash'

function Dashboard({ statisticsInfo }: IDashboardViewModel) {
  const [factory, setFactory] = useState('F01')

  const factoryIndex = findIndex(statisticsInfo, { code: factory })
  const factoryInfo = statisticsInfo?.[factoryIndex]

  return (
    <Main pageTitle='Dashboard'>
      <Container>
        <div className='justify-content-end select-bar'>
          <DropdownButton
            title={`${factoryInfo?.description}`}
            className='dropdown-btn-wrap mt-2'
          >
            {statisticsInfo?.map((info, index) => {
              return <Dropdown.Item key={index} onClick={() => setFactory(info.code)}>{`${info.description}`}</Dropdown.Item>
            })}
          </DropdownButton>
        </div>
      </Container>
      <div className='dashboard'>
        <div className='card-wrap'>
          <div className='card-icon card-icon-complete'>
            <ReactIcons.GrCompliance />
          </div>
          <div>
            <p className='card-title'>今日已組裝完成數量</p>
            <p className='card-counter'>
              {statisticsInfo?.[factoryIndex]?.statistics?.completed}
            </p>
          </div>
        </div>
        <div className='card-wrap'>
          <div className='card-icon card-icon-checked'>
            <ReactIcons.FaClipboardCheck />
          </div>
          <div>
            <p className='card-title'>今日品檢完成數量</p>
            <p className='card-counter'>
            {statisticsInfo?.[factoryIndex]?.statistics?.checked}
            </p>
          </div>
        </div>
        <div className='card-wrap'>
          <div className='card-icon card-icon-assembling'>
            <ReactIcons.TiSpanner />
          </div>
          <div>
            <p className='card-title'>組裝中</p>
            <p className='card-counter'>
            {statisticsInfo?.[factoryIndex]?.statistics?.assembling}
            </p>
          </div>
        </div>
        <div className='card-wrap'>
          <div className='card-icon card-icon-checking'>
            <ReactIcons.FaListCheck />
          </div>
          <div>
            <p className='card-title'>品檢中</p>
            <p className='card-counter'>
            {statisticsInfo?.[factoryIndex]?.statistics?.checking}
            </p>
          </div>
        </div>
      </div>
    </Main>
  )
}

export default bind(Dashboard, DashboardViewModel)
